import { FC } from 'react';

import { SettingsPageMetadata } from '@/shared';

const Metadata: FC = () => <SettingsPageMetadata scope='Workspace' segments={['General']} />;

export default Metadata;
